import { FC } from "react";
import { useQuery } from "@tanstack/react-query";
import { VerificationNames } from "shared/types";
import { Loader } from "shared/components/Loader";
import { Applicant } from "types/application";
import { VerificationReport } from "types/landlord/reports";
import api from "api/landlord/applications";

import { getVerificationQueryKeys } from "../../utils/getVerificationQueryKeys";
import { UnavailableReportView } from "../../components/ReportsFallback/UnavailableReportView";
import { PurchaseApplicationReport } from "./types";
import { PurchaseApplicationReportBody } from "./PurchaseApplicationReportBody";

interface PurchaseApplicationSliceProps {
  applicant: Applicant;
  verificationId: number;
}

export const PurchaseApplicationSlice: FC<PurchaseApplicationSliceProps> = ({
  applicant,
  verificationId
}) => {
  const { data, isLoading } = useQuery({
    queryKey: getVerificationQueryKeys({
      reportName: VerificationNames.BoomFinanceVerification,
      applicationId: applicant.application_id,
      applicantId: applicant.id,
      verificationId
    }),
    queryFn: () =>
      api
        .getApplicantVerification(
          applicant.application_id,
          applicant.id,
          verificationId
        )
        .then(
          (d: {
            verification: VerificationReport<PurchaseApplicationReport>;
          }) => d.verification
        )
  });

  if (isLoading) return <Loader />;

  const report = data?.report;
  if (!report) return <UnavailableReportView />;

  return <PurchaseApplicationReportBody report={report} />;
};
